import 'theme/fonts/Inter/inter.css';

const variables = {
  /* Colours: Figma "Brand-specific colors" → Minor Defense mode */
  /* Primary */
  colorPrimaryMain: '#1F8206',
  colorPrimaryDark: '#134E04',
  colorPrimaryLight: '#DFFDD8',

  /* Border */
  colorBorderMain: '#E6E7E9',
  colorBorderDark: '#C9CCD1',

  /* Typography */
  colorTextOnDark: '#FFFFFF',
  colorTextDisabled: '#A6ABB2',
  colorTextSecondary: '#636870',
  colorTextPrimary: '#15181D',
  colorTextLink: '#1F8206',

  /* Iconography */
  colorIconOnDark: '#FFFFFF',
  colorIconSecondary: '#15181D',
  iconPrimaryFill: '#1F8206',
  iconSecondaryFill: '#134E04',
  iconThirdFill: '#C4F1BB',

  /* Service */
  colorSuccessMain: '#008442',
  colorSuccessLight: '#E9FFD7',
  colorWarningDark: '#8A4000',
  colorWarningMain: '#B85600',
  colorWarningLight: '#FDF1DE',
  colorErrorDark: '#BC1900',
  colorErrorMain: '#DD1D00',
  colorErrorLight: '#FFF4F0',
  colorInfoDark: '#063E93',
  colorInfoMain: '#074EB8',
  colorInfoLight: '#EBF2FF',
  colorPurpleDark: '#9909E0',
  colorPurpleLight: '#F7E5FF',

  /* Background */
  colorBackgroundDefault: '#FFFFFF',
  colorBackgroundLight: '#F9F9FA',
  colorStartGradientBanner: '#DFFDD8',
  colorMiddleGradientBanner: '#D0CFDE',
  colorEndGradientBanner: '#DFFDD8',

  /* Credit score */
  colorCreditScoreVeryPoor: '#F63C45',
  colorCreditScorePoor: '#FFA51F',
  colorCreditScoreFair: '#E8DB21',
  colorCreditScoreGood: '#A3CC28',
  colorCreditScoreVeryGood: '#1A894C',

  /* VPN dark theme */
  colorVpnMain: '#8397D8',
  colorVpnSuccess: '#41B37A',
  colorControlsLight: '#11A75929',
  colorVpnError: '#FF725C',

  /* Non-Figma colours */
  colorIconPrimary: '#312C2C',
  colorSecondaryLight: '#3B3B3B',
  colorTableHeader: '#F2F3F5',
  colorErrorTint: '#FFE6E6',

  fontFamily: 'Inter, sans-serif',
  fontH32: '600 32px/1.5 Inter, sans-serif',
  fontH24: '600 24px/1.5 Inter, sans-serif',
  fontH20: '600 20px/1.6 Inter, sans-serif',
  fontH18: '600 18px/1.55 Inter, sans-serif',
  fontH16: '600 16px/1.5 Inter, sans-serif',
  fontH14: '500 14px/1.57 Inter, sans-serif',
  fontH12: '500 12px/1.5 Inter, sans-serif',
  fontH10: '600 10px/1.6 Inter, sans-serif',
  fontP18: '400 18px/1.55 Inter, sans-serif',
  fontP16: '400 16px/1.5 Inter, sans-serif',
  fontP14: '400 14px/1.57 Inter, sans-serif',
  fontP12: '400 12px/1.5 Inter, sans-serif',
  fontP10: '400 10px/1.6 Inter, sans-serif',

  boxShadow: '0 0.25rem 1rem 0 rgba(0, 0, 0, 0.08)',
  logoHeight: '56px',
};

export default variables;
